export default {
  CHAIN: "robonomics"
};
